<template>
  <div>
    <div class="xinwen">
            <!--top-->
            <div class="top">
                <!--nav-->
                <Nav></Nav>    
                <!--nav-end-->
                <!--banner-->
                <div class="banner">
                                        <div class="layui-carousel" id="test10">
                        <div class="layui-cen" carousel-item="">
                                                        <div>
                                                                <img src="@s/data/uploads/20180705/90766a702215abadac0e36b977b5b229.jpg">                             </div>
                                                    </div>
                    </div>
                </div>
                <!--banner-end-->
            </div>
            <!--top-end-->
            <!--xinwen-center-->
            <div class="xinwen-center">
                <div class="layui-tab">
                    <div class="layui-tab-a">
                                                <ul class="layui-tab-title">
                                                            <li :class="{'layui-this': tab==0 }">
                                    集团动态                                </li>
                                                            <li :class="{'layui-this': tab==1 }">
                                    营销活动                                </li>
                                                            <li :class="{'layui-this': tab==2 }">
                                    媒体报道                                </li>
                                                    </ul>
                    </div>
                    <div class="layui-tab-content">
                                                <div class="layui-tab-item" :class="{'layui-show': tab==0 }">
                            <div id="news_list_12">
                                <div class="layui-tab-item-cen" v-for="(item,i) in listData['0201']" :key="i">
                                    <div class="layui-tab-item-cen-L">
                                        <a :href="'/detail?id='+item.id"> <img :src="item.image" /></a>
                                    </div>
                                    <div class="layui-tab-item-cen-R">
                                        <a :href="'/detail?id='+item.id">
                                            <h5>{{item.title}}</h5></a>
                                        <a :href="'/detail?id='+item.id">
                                            <p>{{item.describe}}</p>
                                        </a>
                                        <a :href="'/detail?id='+item.id"><span>{{item.publishTime}}</span></a>
                                    </div>
                                </div>
                                                       </div>
                            <div id="g_0201" class="duo" style="cursor:pointer;" data-id="0201" data-flag="1" data-page="1">查看更多</div>
                        </div>
                                                <div class="layui-tab-item" :class="{'layui-show': tab==1 }">
                            <div id="news_list_13">
                                 <div class="layui-tab-item-cen" v-for="(item,i) in listData['0202']" :key="i">
                                    <div class="layui-tab-item-cen-L">
                                        <a :href="'/detail?id='+item.id"> <img :src="item.image" /></a>
                                    </div>
                                    <div class="layui-tab-item-cen-R">
                                        <a :href="'/detail?id='+item.id">
                                            <h5>{{item.title}}</h5></a>
                                        <a :href="'/detail?id='+item.id">
                                            <p>{{item.describe}}</p>
                                        </a>
                                        <a :href="'/detail?id='+item.id"><span>{{item.publishTime}}</span></a>
                                    </div>
                                </div>                               
                            </div>
                            <div id="g_0202" class="duo" style="cursor:pointer;" data-id="0202" data-flag="1" data-page="1">查看更多</div>
                        </div>
                                                <div class="layui-tab-item" :class="{'layui-show': tab==2 }">
                            <div id="news_list_14">
                                <div class="layui-tab-item-cen" v-for="(item,i) in listData['0203']" :key="i">
                                    <div class="layui-tab-item-cen-L">
                                        <a :href="'/detail?id='+item.id"> <img :src="item.image" /></a>
                                    </div>
                                    <div class="layui-tab-item-cen-R">
                                        <a :href="'/detail?id='+item.id">
                                            <h5>{{item.title}}</h5></a>
                                        <a :href="'/detail?id='+item.id">
                                            <p>{{item.describe}}</p>
                                        </a>
                                        <a :href="'/detail?id='+item.id"><span>{{item.publishTime}}</span></a>
                                    </div>
                                </div>                                      
                                                     
                            </div>
                            <div id="g_0203" class="duo" style="cursor:pointer;" data-id="0203" data-flag="1" data-page="1">查看更多</div>
                        </div>
                                            </div>

                </div>
            </div>
            <!--xinwen-center-end-->
            <Footer></Footer>
            <!--footer-->
                  

            <!--footer-end-->
        </div>
        <Backtop></Backtop>
  </div>
</template>

<script>
import Nav from '@c/Main/Nav/index.vue'
import Footer from '@c/Main/Footer/index.vue'
import Backtop from '@c/Main/Backtop/index.vue'
import { newsList } from '@/Apis/functions/user'
export default {
    name:'news',
    components: { Nav, Footer, Backtop },
    data(){
        return {
            tab: this.$route.params.tab || 0,
            listData:{
                '0201':[],
                '0202':[],
                '0203':[],
            },
            limit:10
        }
    },
    methods:{
       getNewsList(code,page,fn){
            newsList({
                merchantId:'dwj',
                keyword:'',
                configCode:code,
                offset:(page-1) * this.limit,
                limit:this.limit
            }).then(result => {
                if(result.status==200){
                    if(result.data.length < this.limit){ // 没有下一页了
                      $('#g_'+code).attr('data-flag',0).html('没有更多了！');
                    }
                    this.listData[code] = this.listData[code].concat(result.data)
                    fn && fn()
                }
            })
       } 
    },
    created(){
        this.getNewsList('0201',1)
        this.getNewsList('0202',1)
        this.getNewsList('0203',1)
    },
    mounted(){
           layui.use('element', function() {
            var $ = layui.jquery,
                element = layui.element; //Tab的切换功能，切换事件监听等，需要依赖element模块
        })
        layui.use(['carousel', 'form'], function() {
            var carousel = layui.carousel
            //鍥剧墖杞挱
            carousel.render({
                elem: '#test10',
                width: '100%',
                height: '6.70rem',
                interval: 5000
            });
        })
        var _this = this
        $('.duo').click(function() {
            var page = $(this).attr('data-page');
            var id = $(this).attr('data-id');
            var flag = $(this).attr('data-flag');
            if(flag==1) {
                page++;
                $(this).attr('data-page',page);
                var index = layer.load();
                _this.getNewsList(id,page,() => {
                    layer.close(index);
                })
            }
        });
    }
}
</script>
<style>
@import '~@/static/skin/web/css/xinwen.css';
@import '~@/static/skin/web/css/erji.css';
</style>